
import React from 'react';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

interface ServiceCardProps {
  title: string;
  description: string;
  features: string[];
  icon: LucideIcon;
  link?: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  description,
  features,
  icon: Icon,
  link
}) => {
  return (
    <Card className="flex flex-col h-full bg-white shadow-md hover:shadow-lg transition-shadow duration-300">
      <CardContent className="p-6 flex-grow">
        <div className="flex items-center mb-4">
          <div className="bg-itmgmt-light-gray p-3 rounded-full mr-4">
            <Icon className="h-6 w-6 text-itmgmt-bright-blue" />
          </div>
          <h3 className="text-xl font-bold text-itmgmt-dark-blue">{title}</h3>
        </div>
        
        <p className="text-gray-600 mb-6">{description}</p>
        
        <ul className="space-y-2 mb-6">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
              <span className="text-gray-600">{feature}</span>
            </li>
          ))}
        </ul>
      </CardContent>
      
      <CardFooter className="px-6 pb-6 pt-0 mt-auto">
        <Button asChild className="w-full button-primary" variant="default">
          <Link 
            to={link || '#'} 
            aria-label={`Learn more about ${title} services and solutions`}
            title={`Explore our ${title} services and how they can benefit your business`}
          >
            Explore {title} Solutions
          </Link>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ServiceCard;
